import React from 'react';
import { Phone, BarChart2, Users, Target, Award } from 'lucide-react';
import Container from '../Container';
import Button from '../Button';

const LinkedInLanding = () => {
  const features = [
    {
      icon: BarChart2,
      title: 'Data-Driven Results',
      description: 'ROI-focused strategies backed by analytics'
    },
    {
      icon: Users,
      title: 'Expert Team',
      description: '15+ years of SEO experience'
    },
    {
      icon: Target,
      title: 'Local Focus',
      description: 'Raleigh market specialists'
    },
    {
      icon: Award,
      title: 'Proven Success',
      description: '500+ satisfied clients'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Container>
        <div className="pt-32 pb-20">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Enterprise SEO Solutions for
              <span className="text-blue-600"> B2B Companies</span>
            </h1>

            <p className="text-xl text-gray-600 mb-4">
              Transform your digital presence with enterprise-grade SEO strategies tailored for B2B success
            </p>

            <a href="tel:9192714871" className="flex items-center justify-center text-2xl text-blue-600 font-bold mb-8 hover:text-blue-700">
              <Phone className="h-6 w-6 mr-2" />
              (919) 271-4871
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="bg-white p-6 rounded-xl shadow-md"
              >
                <feature.icon className="h-12 w-12 text-blue-600 mb-4" />
                <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold text-center mb-6">Schedule Your Enterprise SEO Consultation</h2>
            <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="Full Name"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="text"
                placeholder="Company Name"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="email"
                placeholder="Work Email"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <div className="md:col-span-2">
                <textarea
                  placeholder="Tell us about your SEO goals"
                  rows={4}
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
              <div className="md:col-span-2">
                <Button className="w-full text-lg py-4">
                  Book Consultation
                </Button>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default LinkedInLanding;